import axios from 'axios';
//Types
import { SET_KEYCLOAK_USER_DETAILS } from '../user/types';
import { SendOtpPayload, SEND_OTP_REQUEST_FAIL, SEND_OTP_REQUEST_START, SEND_OTP_REQUEST_SUCCESS } from './types';
// Redux
import { getServicesErrorObj } from '../servicesDowntime/actions'
// Utils
import GetBasicDetails from '../../../core/utils/GetBasicDetails';

const SEND_OTP_URL: string = '/affiliate-portal/generateOtp';

export const setKeycloakUserDetailsObj = (payload: any) => ({
  type: SET_KEYCLOAK_USER_DETAILS,
  payload
});

export const updateKeycloakUserDetails = (payload: any) =>
  (dispatch: Function) => {
    dispatch(setKeycloakUserDetailsObj(payload));
  };

export const sentOtpCallRequestStart = () => ({
  type: SEND_OTP_REQUEST_START
});

export const sentOtpCallRequestFail = () => ({
  type: SEND_OTP_REQUEST_FAIL
});

export const sentOtpCallRequestSuccess = (payload: any) => ({
  type: SEND_OTP_REQUEST_SUCCESS,
  payload
});

export const sendOtPCall = (payload: SendOtpPayload) => (
  dispatch: Function
) => new Promise((resolve, reject) => {
  dispatch(sentOtpCallRequestStart());

  const { basicAuthToken: BASIC_AUTH_TOKEN } = GetBasicDetails();

  axios.post(SEND_OTP_URL, payload, {
    headers: {
      "Access-Control-Allow-Origin": "*",
      'Content-Type': 'application/json',
      'Authorization': `Basic ${BASIC_AUTH_TOKEN}`
    }
  })
    .then((response: any) => {
      dispatch(sentOtpCallRequestSuccess(response.data));
      resolve(response.data);
    }).catch((error: any) => {
      dispatch(sentOtpCallRequestFail());
      dispatch(getServicesErrorObj(error));
      reject(error);
    });
});